<template>
<div>

    <m-edit-select
        label="Order Types"
        :value="value"
        :possible_values="items"
        multiple
        v-on:input="onChange"
        :read_only="read_only"
    />
    
    <div
        style="margin-top: 5px"
    >
        Click <a style="text-decoration: underline;" v-on:click="onClickDefaultOrderTypes">here</a> to change the order types that are included by default for your organization
    </div>
    
</div>
</template>

<script>
export default 
{
    props: {
        value: {
            type: Array,
            default: function() { return []; }
        },

        read_only: {
            type: Boolean,
            default: function() { return false; }
        },
    },

    data() {
        return {
            items: [],
        }
    },

    mounted () {
        this.update();
    },

    methods: {
        update() {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/autocomplete/crm_order_type',
            
                'params' : {
                    },
            
                'on_success': (data) => {
                        this.items = data.results;
                    },
            
                'on_error': 'Unable to list order types',
            });
        },

        onChange(new_value)
        {
            this.$emit('input', new_value);
        },

        onClickDefaultOrderTypes()
        {
            this.$router.push({
                'name': 'settings-organization-order-attribution',
                'params' : {
                    'organization_id': this.$rc.getOrganizationId()
                }
            });
        },
    },
}
</script>

<style lang="scss" scoped>

</style>